import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BranchList from './Branch/BranchList';
import AddLocationList from './AddLocation/AddLocationList';
import SpecializationList from './Specialization/SpecializationList';
import SemesterList from './Semester/SemesterList';
import { Grid } from '@mui/material';


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  
  return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 1 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
  );
}
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }


  const MastersListTools = () => {
    
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Box >
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
              variant='scrollable'
              visibleScrollbar={true}
              allowScrollButtonsMobile
              style={{overflow: 'auto',
                  width:'89vw'
              }}>
              <Tab label="Location" {...a11yProps(0)} />
              <Tab label="Hostel Name" {...a11yProps(1)} />
              <Tab label="Specialization" {...a11yProps(2)} />
              <Tab label="Year" {...a11yProps(3)} />
              {/* <Tab label="Section" {...a11yProps(4)} />
              <Tab label="Subject" {...a11yProps(5)} />
              <Tab label="Class Type" {...a11yProps(6)} /> */}
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <AddLocationList />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <BranchList />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <SpecializationList />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <SemesterList />
          </TabPanel>
          {/* <TabPanel value={value} index={4}>
            <SectionList />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <SubjectList />
          </TabPanel>
           <TabPanel value={value} index={6}>
            <ClasstypeList />
           </TabPanel> */}
        </Box>
      </Grid>
    </Grid>
  )
}

export default MastersListTools
